var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Children, Component, useContext, useEffect } from 'react';
import { AwesomeComponent, ComponentType, Container } from '@philips-internal/oswald-ui-core';
import { useEditorContext } from '@philips-internal/oswald-ui-core/lib/component/context/index.js';
import { EngineContext } from '@philips-internal/oswald-ui-engine';
import { useGlobalActionsStack } from '../../context/global-actions-stack-context.js';
import GlobalActionsAPI from './global-actions-api.js';
const GlobalActionsContainer = {
    acceptedTypes: [
        ComponentType.NAVIGATION,
    ],
    name: '',
};
function GlobalActionsContent(props) {
    const engineContext = useContext(EngineContext);
    const editorContext = useEditorContext();
    const globalActionsStackContext = useGlobalActionsStack();
    useEffect(() => {
        const popActions = globalActionsStackContext.pushActions({
            actions: props.children,
            fragmentInstanceUUID: engineContext?.root?.getInstanceUUID(),
        });
        return () => {
            popActions();
        };
    }, [props.children]);
    if (!editorContext?.isDesigning() || Children.count(props.children) >= 2) {
        return null;
    }
    return (React.createElement(Container, { acceptedTypes: GlobalActionsContainer.acceptedTypes, className: "u-expand", uuid: props.uuid }));
}
let GlobalActions = class GlobalActions extends Component {
    render() {
        return (React.createElement(GlobalActionsContent, { ...this.props }));
    }
};
GlobalActions = __decorate([
    AwesomeComponent({ api: GlobalActionsAPI, containers: [GlobalActionsContainer], type: ComponentType.BEHAVIOR })
], GlobalActions);
export default GlobalActions;
//# sourceMappingURL=global-actions.js.map